import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import WalletConnection from './WalletConnection';

const Navbar = ({ isWalletConnected, walletAddress, onConnect, onDisconnect, user, onLogout }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  
  const toggleUserMenu = () => {
    setShowUserMenu(!showUserMenu);
  };
  
  const handleLogout = () => {
    onLogout();
    setShowUserMenu(false);
  };
  
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo-wrapper">
          <Link to="/" className="navbar-logo-center">
            <img 
              src="/images/mythid-logo.png" 
              alt="MYTHID" 
              className="navbar-logo-image" 
            />
          </Link>
        </div>

        {/*
        <div className="navbar-links">
          <Link to="/" className="navbar-link">Explore</Link>
          <Link to="/collections" className="navbar-link">Collections</Link>
          <Link to="/artists" className="navbar-link">Artists</Link>
          <Link to="/activity" className="navbar-link">Activity</Link>
          <Link to="/create-nft" className="create-nft-button">Create NFT</Link>
        </div>
        */}

        <div className="navbar-right">
          {user ? (
            <div className="user-account">
              <div className="user-profile" onClick={toggleUserMenu}>
                <img 
                  src={user.avatar || "/api/placeholder/40/40"} 
                  alt={user.name}
                  className="user-avatar" 
                />
                <span className="user-name">{user.name}</span>
              </div>
              
              {showUserMenu && (
                <div className="user-menu">
                  <Link to="/collection" className="user-menu-item">
                    My Collection
                  </Link>
                  <Link to="/profile" className="user-menu-item">
                    Profile Settings
                  </Link>
                  <div className="user-menu-divider"></div>
                  <div className="user-menu-item" onClick={handleLogout}>
                    Logout
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="auth-buttons">
              <Link to="/login" className="login-button">Login</Link>
              <Link to="/register" className="register-button">Sign Up</Link>
            </div>
          )}
          
          <WalletConnection 
            isConnected={isWalletConnected}
            walletAddress={walletAddress}
            onConnect={onConnect}
            onDisconnect={onDisconnect}
          />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;